import { Button, Card, Grid, Typography, Fab, InputAdornment, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import api from "../../../components/services/api";
import useDebounce from "../../../libs/hooks/useDebounce";
import { Box } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import DowloadBT from "../components/dowloadBT";
import { useHistory } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import SearchIcon from "@mui/icons-material/Search";
export default function EIR() {
  const history = useHistory();

  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  // const [openPage, setOpenPage] = useState(false);
  const MenuActive = useSelector((state) => state.MenuActive.List);
  const [key,setKey] =useState('')
  
  const debouncedKey = useDebounce(key, 500);
  /* table data */
  const ShipScheduleList = async () => {
    try {
      const result = await api.get(`api/eir/list?keyword=${debouncedKey}`);
      setData(result.data);
      setDataFilter(result.data);
    } catch (error) {
      console.log("error => ", error);
    }
  };
  const columns = [
    { field: "EIRNo", headerName: "EIR No.", width: 150 },
    // { field: "TugName", headerName: "EIR TYPE", width: 200 },

    { field: "SaleOrderNo", headerName: "SaleOrder No.", width: 150 },
    { field: "BookingNo", headerName: "Booking No.", width: 150 },
    { field: "CustomerName", headerName: "Customer Name", width: 200 },
    { field: "TruckCompany", headerName: "Truck Company", width: 200 },
    { field: "TruckNo", headerName: "Truck No", width: 100 },

    {
      field: "EIR_Date",
      headerName: "DATE",
      width: 150,
      valueFormatter: ({ value }) => {
        return moment(value).format("YYYY-MM-DD");
      },
    },
    { field: "EIRTime", headerName: "Time", width: 80 },
    { field: "Status", headerName: "Status", width: 80 },

    // {
    //   field: "Voyage",
    //   headerName: "VOYAGE NO.",
    //   width: 200,
    //   renderCell: (params) => {
    //     return (
    //       <div>
    //         <span>
    //           {params.row.LocFrom} - {params.row.LocTo}
    //         </span>
    //       </div>
    //     );
    //   },
    // },



    // {
    //   field: "LocTo",
    //   headerName: "container",
    //   width: 200,
    //   renderCell: (params) => {
    //     return (
    //       <div>
    //         <span>
    //           {params.row.LocTo} - {params.row.LocFrom}
    //         </span>
    //       </div>
    //     );
    //   },
    // },
    // { field: 1, headerName: "seal no", width: 200 },
    // { field: 2, headerName: "size type", width: 200 },

    {
      field: "Action",
      width: 180,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Link
              to={{
                pathname: `/Truck/EditEIR/${params.id}`,
                state: params.row.VoyageIn,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF" }}
              >
                View
              </Button>
            </Link>

            <Button
              variant="contained"
              style={{ textTransform: "none", backgroundColor: "rgb(245, 60, 86)", marginLeft:'10px' }}
              onClick={() => {
                const body = {
                  EIRId: params.id,
                }
                const updateStuts = async () => {
                  const res = await api.post(`api/eir/delete`, body)
                  const data = await res.data
                  if (res.meta.status) {
                    Swal.fire({
                      title: `${res.meta.message}`,
                      icon: 'success',
                      confirmButtonColor: '#3085d6',
                      confirmButtonText: 'OK',
                      allowOutsideClick: false
                    }).then((result) => {
                      if (result.isConfirmed) {
                        ShipScheduleList()
                      }
                    })
                  }
                }
                Swal.fire({
                  title: 'Are you sure?',
                  // text: "You won't be able to revert this!",
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes, delete it!',
                  allowOutsideClick: false
                }).then((result) => {
                  if (result.isConfirmed) {
                    updateStuts()
                  }
                })
              }}

            >
              Delete
            </Button>
          </>
        );
      },
    },
  ];

  const floating_action_style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 10,
    left: "auto",
    position: "fixed",
  };

  

  useEffect(() => {
    ShipScheduleList();
  }, [debouncedKey]);

  const handleOpenPage = () => {
    history.push("/Truck/AddE.I.R");
  };

  return (
    <>
      <Card
        variant="outlined"
        style={{ padding: "20px", margin: "25px", height: "86vh" }}
      >
        {/* <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          แผนตารางเรือ
        </h6> */}

        <Grid container alignItems="center" spacing={1} sx={{ marginTop: 3 }}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Equipment Interchange Receipt (EIR)
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Truck</Typography>
            <Typography>
              <span>&nbsp;</span> / E.I.R
            </Typography>
          </Grid>
        </Grid>

        <Grid
          //   container
          //   sx={{ justifyContent: "end" }}
          style={{ marginTop: "10px", display: "flex", flexDirection: "row" }}
        >
          <DowloadBT />

      
          <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  disableUnderline: true,
                }}
                label="Search"
                onChange={(e) => setKey(e.target.value)}
                size="small"
              />
        </Grid>

        <Box
          sx={{
            height: 650,
            width: "100%",
            marginTop: "10px",
          }}
        >
          <DataGrid
            getRowId={(r) => r.EIRId}
            rows={dataFilter}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            hideFooterSelectedRowCount
            disableColumnFilter
            disableColumnMenu
          />
        </Box>
      </Card>
      {MenuActive.find((x) => x.ActionNo === "A037") && (
        <Link to="/Truck/AddE.I.R">
          <Fab color="primary" style={floating_action_style} aria-label="add">
            <AddIcon />
          </Fab>
        </Link>
      )}
    </>
  );
}
